<script>
import Faker from 'faker'
import CopyToClipboard from './CopyToClipboard'

const PRIVATE_KEYS = ["definitions", "fake", "locale", "localeFallback", "locales", "helpers"]

export default {

  components: {
    CopyToClipboard
  },

  data() {
    return {
      fakerOptions: this.generateFakeData()
    }
  },

  methods: {
    reload() {
      this.fakerOptions = this.generateFakeData()
    },

    fetchFakerOptions(object, carry="Faker"){
      let result = []
      for (let [key, value] of Object.entries(object)) {
        if (PRIVATE_KEYS.indexOf(key) >= 0) { continue }

        if (typeof value == "object") {
          result.push(...this.fetchFakerOptions(value, `${carry}.${key}`))
        } else if(typeof value == "function") {
          result.push({
            label: `${carry}.${key}`,
            example: value()
          })
        }
      }
      return result
    },

    generateFakeData() {
      let fakerOptions = {}

      let rootKeys = Object.keys(Faker).filter((key)=>{
        return PRIVATE_KEYS.indexOf(key) < 0
      }).sort()

      for(let rootKey of rootKeys) {
        fakerOptions[rootKey] = this.fetchFakerOptions(Faker[rootKey], `Faker.${rootKey}`)
      }
      return fakerOptions
    }
  }

}
</script>

<template>
  <div>
    <h3 class="is-size-4">Faker.js</h3>
    <br>
    <p>
      This tool uses <a href="https://github.com/Marak/Faker.js" target="_blank" rel="nofollow">Faker.js (Github)</a> for generating realistic fake data.
      You can try out Faker.js right here in the developer console.
    </p>
    <br>
    <p>
      Find a list of available Faker functions below:
    </p>
    <br>
    <div>
      <section v-for="(values, key) in fakerOptions">

        <h3 class="is-size-5">{{ key }}</h3>
        <ul class="box">
          <li v-for="value in values">
            <div class="columns">
              <div class="column is-narrow">
                <copy-to-clipboard title="Copy" buttonType="is-text" :content="value.label"></copy-to-clipboard>
              </div>
              <div class="column faker-function">{{ value.label }}</div>
              <div class="column faker-value">{{ value.example }}</div>
            </div>
          </li>
        </ul>
        <br>

      </section>
    </div>
  </div>
</template>

<style lang="scss">
.faker-value, .faker-function {
  line-height: 36px;
}
.faker-function {
  font-family: monospace;
}
</style>